/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

angular.module('zeppelinWebApp').controller('NotebookRepositoryCtrl', NotebookRepositoryCtrl);

function NotebookRepositoryCtrl($scope, $http, $timeout, websocketMsgSrv, baseUrlSrv, ngToast) {
  'ngInject';

  let vm = this;
  vm.revisionControlConfig = {
    remoteUrl: '',
    userName: '',
    accessToken: '',
  };
  vm.savingConfig = false;
  vm.isConfigured = false;
  vm.isConfiguring = false;
  vm.startConfiguring = startConfiguring;
  vm.clearAccessToken = clearAccessToken;
  vm.starAccessToken = starAccessToken;
  vm.saveRevisionControlConfig = saveRevisionControlConfig;
  vm.removeRevisionControlConfig = removeRevisionControlConfig;
  vm.successText = '';
  vm.errorText = '';
  vm.isError = false;
  getRevisionControlConfig();

  $scope.callAtTimeout = function() {
    if (vm.isConfiguring) {
      vm.isError = true;
      vm.errorText = 'The revision control configuration request may have experienced a timeout.' +
        ' For exceptionally large notebook repositories, this request may still be syncing.' +
        ' Please try again or contact support@silect.is for further assistance.';
      vm.isConfiguring = false;
      getRevisionControlConfig();
      vm.savingConfig = false;
    }
  };

  $scope.$on('repoSyncSuccess', function(event, param) {
    vm.isConfiguring = false;
    vm.savingConfig = false;
    if (vm.isError) {
      console.log('Revision control config cleared and synced.');
    } else {
      vm.errorText = '';
      vm.successText = 'Change to revision control configuration was successfully applied.';
    }
  });

  $scope.$on('repoSyncError', function(event, param) {
    vm.successText = '';
    vm.errorText = 'There was an error applying the given revision control configuration. ' +
      'Please validate the configuration provided or contact support@silect.is for further assistance.';
    vm.isError = true;
    deleteRevisionControlConfig();
  });

  function startConfiguring() {
    vm.errorText = '';
    vm.successText = '';
    vm.isConfiguring = true;
  }

  function resetNotebooks() {
    websocketMsgSrv.reloadAllNotesFromRepo();
  }

  function clearAccessToken() {
    vm.revisionControlConfig.accessToken = '';
  }

  function starAccessToken() {
    vm.revisionControlConfig.accessToken = '********';
  }

  function getRevisionControlConfig() {
    $http.get(baseUrlSrv.getRestApiBase() + '/magpie/revision-control')
      .success(function(data) {
        if (data.config) {
          vm.revisionControlConfig = data.config;
          vm.isConfigured = true;
        } else {
          vm.isConfigured = false;
        }
      }).error(function(data, status, headers, config) {
        if (status !== 0) {
          console.log('Error %o %o', status, data.message);
        }
        ngToast.danger({
          content: 'We couldn\'t get the revision control configuration for this notebook!',
          verticalPosition: 'bottom',
          timeout: '3000',
        });
      });
  }

  function saveRevisionControlConfig(valueform, configData) {
    vm.isError = false;
    vm.savingConfig = true;
    $http.post(baseUrlSrv.getRestApiBase() + '/magpie/revision-control',
      JSON.stringify(configData))
        .success(function(data) {
          $timeout($scope.callAtTimeout, 300000);
          resetNotebooks(true);
          getRevisionControlConfig();
        })
        .error(function(data, status, headers, config) {
          getRevisionControlConfig();
          if (status !== 0) {
            console.log('Error %o %o', status, data.message);
          }
          ngToast.danger({
            content: 'We couldn\'t save the revision control configuration for this notebook.' +
              ' Please try again.',
            verticalPosition: 'bottom',
            timeout: '6000',
          });
          vm.isConfiguring = false;
          vm.savingConfig = false;
        });
  }

  function deleteRevisionControlConfig() {
    vm.savingConfig = true;
    $http.post(baseUrlSrv.getRestApiBase() + '/magpie/revision-control', '')
      .success(function(data) {
        resetNotebooks();
        vm.isConfigured = false;
        vm.revisionControlConfig = {
          remoteUrl: '',
          userName: '',
          accessToken: '',
        };
      })
      .error(function(data, status, headers, config) {
        if (status !== 0) {
          console.log('Error %o %o', status, data.message);
        }
        ngToast.danger({
          content: 'We couldn\'t remove the revision control configuration for this notebook.' +
            ' Please try again.',
          verticalPosition: 'bottom',
          timeout: '6000',
        });
      });
  }

  function removeRevisionControlConfig() {
    vm.isError = false;
    BootstrapDialog.confirm({
      closable: true,
      title: '',
      message: 'Do you want to delete this revision control config?',
      callback: function(result) {
        if (result) {
          console.log('Remove config');
          deleteRevisionControlConfig();
        }
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/notebook-repository/notebook-repository.controller.js